export default function priceFixed(price) {
    const fixedPrice = price - Math.floor(price) !== 0 ? price.toFixed(2) : price;
    return fixedPrice;
}
